import { FC, memo, useMemo, useRef } from 'react';
import dynamic from 'next/dynamic';
import styled from 'styled-components';
import { useOnScreen } from '../../../hooks/useOnScreen';
import { imageFromCDN } from '../../../lib/utils';
import type { CompanyMapProps } from './CompanyMapContent';

const Container = styled.div`
  position: relative;
  width: 50%;
  max-height: 435.4px;

  > div {
    padding-top: 169.88%;
  }

  > svg,
  > img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;

const FakeMap = memo(() => <img alt="toimialueet kartalla" src={imageFromCDN('/emptyMap.svg')} width={256.3} height={435.4} />);

export const CompanyMap: FC<CompanyMapProps> = ({ operationalAreas }) => {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const isVisible = useOnScreen(containerRef, { onlyOnce: true });

  // Import map only if required
  const CompanyMapContent = useMemo(
    () =>
      isVisible
        ? dynamic(() => import('./CompanyMapContent').then(({ CompanyMapContent }) => CompanyMapContent), { loading: () => <FakeMap /> })
        : FakeMap,
    [isVisible]
  );

  return (
    <Container ref={containerRef}>
      <div />
      <CompanyMapContent operationalAreas={operationalAreas} />
    </Container>
  );
};
